var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{attrs:{"align":"center"}},[_vm._v(" Das solltest du hier eigentlich nicht sehen.... ")])}
var staticRenderFns = []

export { render, staticRenderFns }